// React Libraries
import React, { Component } from 'react';

// UI Components
import Logo from 'Components/Logo';
import SiteNav from 'Components/SiteNav.js'
import NavToggle from 'Components/NavToggle.js'

// Styling
import 'assets/css/components/header.css';

import {
  withRouter
} from "react-router-dom";

// Create Header Class
class Header extends Component {
  constructor() {
		super();

		this.state = {
      navActive: ''
    }

		this.toggleNav = this.toggleNav.bind(this);
    this.updateNavActiveState = this.updateNavActiveState.bind(this);
	}

	toggleNav() {
		var toggle = this.state.navActive === 'is-active' ? '' : 'is-active';
    this.updateNavActiveState(toggle);

	}

  updateNavActiveState(toggle) {
    this.setState({
      navActive: toggle
    });
  }

  componentWillMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      this.updateNavActiveState('');
    });
  }

  componentWillUnmount() {
      this.unlisten();
  }

  render() {
    return (
      <React.Fragment>
        <header className={`hdr${this.props.isHeaderSticky ? ' is-hdr-sticky' : ''}${this.state.navActive === 'is-active' ? ' is-nav-active' : ''}${this.props.isAltHeader ? ' is-hdr-alt' : ''}`}>
          <div className="hdr__container container">
            <Logo />
            <SiteNav navActive={''} isPhone="false" />
            <NavToggle navActive={this.state.navActive} onNavUpdate={this.updateNavActiveState} onClick={this.toggleNav} />
          </div>
        </header>
        <SiteNav navActive={this.state.navActive} isPhone="true" />
      </React.Fragment>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/Components/Header.js